import CreateAccount from './components/CreateAccount.vue'
import AddressRegister from './components/AddressRegister.vue'
import Menu from './components/menu.vue'
import NewDetails from './components/NewDetails.vue'
import Confirm from './components/confirm.vue'
import Payment from './components/payment.vue'
import OrderInProcess from './components/OrderInProcess.vue'
import Logo from './components/logo.vue'
import Verification from './components/Verification.vue'
import newStructure from './components/newStructure.vue'
import Ubication from './components/ubication.vue'
import welcome from './components/welcome.vue'
import registerStep1 from './components/registerStep1.vue'
import registerStep2 from './components/registerStep2.vue'
import registerStep3 from './components/registerStep3.vue'
import userprofile from './components/userProfile/profile.vue'
import structureTest from './components/userProfile/structureTest.vue'
import newAddress from './components/userProfile/createUserData/NewAddress.vue'
import newAddress2 from './components/userProfile/createUserData/NewAddress2.vue'
import editAddress from './components/userProfile/createUserData/editAddress.vue'
import editAddress2 from './components/userProfile/createUserData/editAddress2.vue'
import newPaymentMethod from './components/userProfile/createUserData/NewPaymentMethod.vue'
import order from './components/order.vue'
import orderDetails from './components/orderDetails.vue'
import restorePassword from './components/restorePassword.vue'
import loginDeliveryMan from './components/deliveryMan/loginDeliveryMan.vue';
import ordersDeliveryMan from './components/deliveryMan/ordersDeliveryMan.vue';
import ordersDetailDelivery from './components/deliveryMan/ordersDetailDelivery.vue';
import statusOrderDelivery from './components/deliveryMan/statusOrderDelivery.vue';
import finalOrder from './components/finalOrder.vue';
import finished from './components/finished.vue';
import finishedError from './components/finishedError.vue';
import newPass from './components/userProfile/newPass.vue';
import select_delivery from './components/select_delivery.vue';
import newPay from './components/newPay.vue';
import store from './store/index.js'

  const ifNotAuthenticated = (to, from, next) => {
    if (!store.getters.isAuthenticated) {
      next();
      return;
    }
    next('/menu');
  }
  
  const ifAuthenticated = (to, from, next) => {
    if (store.getters.isAuthenticated) {
        store.state.logo = true;
        next();
        return;
    }
    next('/verification');
  }
  const ifNotAuthenticatedDM = (to, from, next) => {
    if (!store.getters.isAuthenticatedDM) {
      next();
      return;
    }
    next('/ordersDeliveryMan');
  }
  
  const ifAuthenticatedDM = (to, from, next) => {
    if (store.getters.isAuthenticatedDM) {
        store.state.logo = true;
        next();
        return;
    }
    next('/loginDeliveryMan');
  }

export const routes = [
    {path: '', component: Logo, name: 'logo'},
    {path: '/restorePassword/:token', component: restorePassword, name: 'restorePassword', beforeEnter: ifNotAuthenticated },
    {path: '/newStructure', component: newStructure, name: 'newStructure', beforeEnter: ifNotAuthenticated },
    {path: '/ubication', component: Ubication, name: 'ubication', beforeEnter: ifNotAuthenticated},
    {path: '/welcome', component: welcome, name: 'welcome', beforeEnter: ifNotAuthenticated },
    {path: '/registerStep1', component: registerStep1, name: 'registerStep1', beforeEnter: ifNotAuthenticated },
    {path: '/registerStep2', component: registerStep2, name: 'registerStep2', beforeEnter: ifNotAuthenticated },
    {path: '/registerStep3', component: registerStep3, name: 'registerStep3', beforeEnter: ifNotAuthenticated },
    {path: '/verification', component: Verification, name: 'verification', beforeEnter: ifNotAuthenticated},
    {path: '/loginDeliveryMan', component: loginDeliveryMan, name: 'loginDeliveryMan', beforeEnter: ifNotAuthenticatedDM},
    {path: '/menu', component: Menu, name: 'menu', beforeEnter: ifAuthenticated},
    {path: '/structureTest', component: structureTest, name: 'structureTest', beforeEnter: ifAuthenticated},
    {path: '/userprofile', component: userprofile, name: 'userprofile', beforeEnter: ifAuthenticated},
    {path: '/newAddress', component: newAddress, name: 'newAddress', beforeEnter: ifAuthenticated},
    {path: '/newAddress2', component: newAddress2, name: 'newAddress2', beforeEnter: ifAuthenticated},
    {path: '/editAddress', component: editAddress, name: 'editAddress', beforeEnter: ifAuthenticated},
    {path: '/editAddress2', component: editAddress2, name: 'editAddress2', beforeEnter: ifAuthenticated},
    {path: '/newPaymentMethod', component: newPaymentMethod, name: 'newPaymentMethod', beforeEnter: ifAuthenticated},
    {path: '/order', component: order, name: 'order', beforeEnter: ifAuthenticated},
    {path: '/orderDetails/:id', component: orderDetails, name: 'orderDetails', beforeEnter: ifAuthenticated},
    {path: '/address_register', component: AddressRegister, name: 'address_register', beforeEnter: ifAuthenticated},
    {path: '/create_account', component: CreateAccount, name: 'create_account', beforeEnter: ifAuthenticated},
    {path: '/details', component: NewDetails, name: 'details', beforeEnter: ifAuthenticated},
    {path: '/confirm', component: Confirm, name: 'confirm', beforeEnter: ifAuthenticated},
    {path: '/payment', component: Payment, name: 'payment', beforeEnter: ifAuthenticated},
    {path: '/finished', component: finished, name: 'finished', beforeEnter: ifAuthenticated},
    {path: '/newPay', component: newPay, name: 'newPay', beforeEnter: newPay},
    {path: '/finished_error', component: finishedError, name: 'finished_error', beforeEnter: ifAuthenticated},
    {path: '/final_order', component: finalOrder, name: 'final_order', beforeEnter: ifAuthenticated},
    {path: '/order_in_process', component: OrderInProcess, name: 'order_in_process', beforeEnter: ifAuthenticated},
    {path: '/ordersDeliveryMan', component: ordersDeliveryMan,name: 'orders_delivery_man', beforeEnter: ifAuthenticatedDM},
    {path: '/ordersDetailDelivery/:id', component: ordersDetailDelivery,name: 'orders_detail_delivery', beforeEnter: ifAuthenticatedDM},
    {path: '/statusOrder', component: statusOrderDelivery,name: 'status_order', beforeEnter: ifAuthenticated},
    {path: '/newPass', component: newPass,name: 'newPass', beforeEnter: ifAuthenticated},
    {path: '/select_delivery', component: select_delivery,name: 'select_delivery', beforeEnter: ifAuthenticated},

    // {path: '/forgotPass', component: forgotPass, name: 'forgotPass'},
    // {path: '/evaluateOrder', component: evaluateOrder, name: 'evaluateOrder'},
    {path: '*', redirect: '/' },
    

]